import { render, staticRenderFns } from "./MenuClienti.vue?vue&type=template&id=1cd7b37c&"
import script from "./MenuClienti.vue?vue&type=script&lang=js&"
export * from "./MenuClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports